module.exports = __webpack_public_path__ + "img/fresh.25ee79d6.png";